<template>
  <div class="ai-agent-management">
    <TableList
      v-rect-loading="loading"
      class="ai-agent-list"
      row-key="id"
      :title="$t(`${i18nPrefix}.title.aiAgentManagement`)"
      :listData="aiAgentList"
      :tableColumns="tableColumns"
      :actionBtn="actionBtn"
      :showCreateBtn="false"
    >
      <!-- 暂时不需要单独配置公司Agent -->
      <!-- <template #filter>
        <el-select v-model="search.rootCompanyId" clearable filterable @change="handleCompanyChange">
          <el-option
            v-for="(company, index) in rootCompanyList"
            :key="index"
            :label="`${company.id} - ${company.i18nName}`"
            :value="company.id"
          ></el-option>
        </el-select>
      </template> -->
    </TableList>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'
import { addI18nProperty } from '@/i18n'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import { COMPANY_STATUS } from '@/constant/company'

export default {
  components: {
    TableList
  },
  data () {
    return {
      i18nPrefix: 'admin.company.aiAgentManagement',
      loading: false,
      rootCompanyList: [],
      aiAgentList: [],
      search: {
        rootCompanyId: null
      },
      actionBtn: {
        editor: {
          show: true,
          onclick: this.handleEdit,
          labelI18nKey: 'common.btn.edit'
        }
      }
    }
  },
  computed: {
    tableColumns () {
      return [
        // {
        //   label: this.$t(`${this.i18nPrefix}.label.companyName`),
        //   dataKey: 'root_company.i18nName'
        // },
        {
          label: this.$t(`${this.i18nPrefix}.label.agentName`),
          dataKey: 'agent.name'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.agentDescription`),
          dataKey: 'agent.description',
          showOverflowTooltip: true
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.modelName`),
          dataKey: 'model.name'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.version`),
          dataKey: 'version'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.updateTime`),
          dataKey: 'updated_time',
          formatter: (data) => {
            return moment(data).format('YYYY-MM-DD HH:mm:ss')
          }
        }
      ]
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('ai', ['getAIAgentList']),
    ...mapActions('superAdmin', ['getSuperAdminCompanyList']),
    initPage () {
      this.loadAIAgentList()
      // this.loadCompanyList()
    },
    async loadAIAgentList () {
      this.loading = true
      const params = {
        root_company_id: this.search.rootCompanyId
      }
      try {
        const resp = await this.getAIAgentList(params)
        if (resp) {
          _.forEach(resp, item => {
            if (!item.root_company) {
              item.root_company = {
                name: 'Default Agent',
                cn_name: '默认Agent'
              }
            }
            addI18nProperty(item.root_company, 'i18nName', 'cn_name', 'name')
          })
          this.aiAgentList = resp
        }
      } finally {
        this.loading = false
      }
    },
    async loadCompanyList () {
      const resp = await this.getSuperAdminCompanyList({ only_root_company: 1, status: COMPANY_STATUS.APPROVED })
      if (resp) {
        this.rootCompanyList = _.map(resp.result, com => {
          if (!com.cn_name) {
            com.cn_name = com.name
          }
          if (!com.name) {
            com.name = com.cn_name
          }
          addI18nProperty(com, 'i18nName', 'cn_name', 'name')
          return com
        })
      }
    },
    handleCompanyChange () {
      this.loadAIAgentList()
    },
    handleEdit (row) {
      this.$router.push({
        path: `/v-admin/client-admin/ai-agent-management/edit/${row.id}/`
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
